// extracted by mini-css-extract-plugin
export default {"container":"Products_container__kig0t","products":"Products_products__jHgwR","menu":"Products_menu__4jCDg","list":"Products_list__UM48K","product":"Products_product__vQnj-"};